import { css } from '@emotion/react'

export const navItemBaseCSS = css`
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  font-family: var(--font-family-system);
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
`

export const navItemHoverBgCSS = css`
  background: #F9EFE4;
  border-radius: 999px;
`
